import { render, staticRenderFns } from "./DownloadRow.vue?vue&type=template&id=86d998fc&scoped=true&"
import script from "./DownloadRow.vue?vue&type=script&lang=ts&"
export * from "./DownloadRow.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadRow.vue?vue&type=style&index=0&id=86d998fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d998fc",
  null
  
)

export default component.exports